import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { MoodDescriptionDialogController } from 'dialog/mood-description-dialog/mood-description-dialog.controller';

@Component({
	selector: 'spr-mood-description-dialog',
	templateUrl: './mood-description-dialog.component.html',
	providers: [MoodDescriptionDialogController],
	host: {
		class: 'flex flex-col items-stretch space-y-3',
	},
})
export class MoodDescriptionDialogComponent {
	constructor(
		private _dialogRef: DynamicDialogRef,
		public controller: MoodDescriptionDialogController
	) {}

	public onCancelClick() {
		this._dialogRef.close();
	}

	public onStartClick() {
		this.controller.openCoacheeMoodDialog();
		this._dialogRef.close();
	}
}
